/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
window.route = require('@/route');
import { App, plugin } from '@inertiajs/inertia-vue'
import { Inertia } from '@inertiajs/inertia'
import NProgress from 'nprogress'
import Vue from 'vue'
import vuetify from '@/plugins/Vuetify';
import firebase from 'firebase';
import VuePlyr from 'vue-plyr';
import store from '@/store/index'
import 'vue-plyr/dist/vue-plyr.css';
global.moment = window.moment = require('moment').default;
 
Vue.use(plugin);
Vue.use(require('vue-moment'));
Vue.use(VuePlyr, {
  plyr: {

  }
});

Vue.prototype.route = window.route;

const app = document.getElementById('app');

var firebaseConfig = {
  apiKey: "AIzaSyDouBBiBBRdGILl7UM0GQt3yYHxPFLsvrA",
  authDomain: "brartist-c47d3.firebaseapp.com",
  databaseURL: "https://brartist-c47d3.firebaseio.com",
  projectId: "brartist-c47d3",
  storageBucket: "brartist-c47d3.appspot.com",
  messagingSenderId: "1085462696311",
  appId: "1:1085462696311:web:9e84cb3a3fb26074be9172"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

if (process.env.MIX_APP_ENV === 'production') {
    Vue.config.productionTip = false;
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true; 
} else {
  Vue.config.devtools = true;
  Vue.config.debug = true;
  Vue.config.silent = false; 
}

Vue.mixin({
    computed:{
      currentUser(){ 
        return this.$page.props.auth.logged.user;
      },
      artista_id(){
        return this.$page.props.artista_id;
      },
      tenant(){
        return this.$page.props.tenant;
      }
    },
});

// Progressbar configuration
Inertia.on('start', () => NProgress.start())
Inertia.on('finish', () => NProgress.done())

new Vue({
    vuetify,
    store,
    render: h => h(App, {
        props: {
          initialPage: JSON.parse(app.dataset.page),
          resolveComponent: name => require(`./Pages/${name}`).default,
        },
    }),
}).$mount(app)